module.exports = __webpack_public_path__ + "static/media/logo3.d8a97a48.svg";